'use client';

import { Globe } from 'lucide-react';
import { useParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { usePathname, Link } from '@/i18n/navigation';

export function LanguageSwitcher() {
  const locale = useLocale();
  const pathname = usePathname();
  const params = useParams();

  return (
    <div className="flex items-center gap-1 text-sm">
      <Globe size={16} className="text-neutral-400" />
      {(['fr', 'en'] as const).map((l) =>
        l === locale ? (
          <span key={l} className="px-2 py-1 rounded bg-brand-100 text-brand-700 font-medium">
            {l.toUpperCase()}
          </span>
        ) : (
          <Link
            key={l}
            href={{ pathname, params } as Parameters<typeof Link>[0]['href']}
            locale={l}
            className="px-2 py-1 rounded text-neutral-500 hover:text-neutral-700"
          >
            {l.toUpperCase()}
          </Link>
        ),
      )}
    </div>
  );
}
